import * as yup from 'yup';
import { ABAAppointmentSubType } from 'model/abaAppointmentSubtype';

export const ABA_APPOINTMENT_SUBTYPE_SCHEMA = () =>
  yup.object().shape({
    [ABAAppointmentSubType.title]: yup.string().required('Title is required'),
    [ABAAppointmentSubType.placeOfService]: yup.object().shape({
      id: yup.string().required('Place Of service is required')
    }),
    [ABAAppointmentSubType.superType]: yup.object().shape({
      id: yup.string().required('Supertype is required')
    })
  });
